// ============================================================
// Commission Config — cluster gating for commission features
// ============================================================

// Clusters that support commission/settlement tracking.
// A = Appointment (salon, spa, clinic), F = Automotive (bays/techs).
// Category→cluster resolution is the Industry Engine resolver's job
// (resolveClusterConfig / useResolvedClusterConfig); this module only
// gates on an already-resolved cluster key.
const COMMISSION_CLUSTERS = new Set(['A', 'F']);

/**
 * Check if a cluster supports commission tracking.
 */
export function supportsCommissions(clusterKey: string | null | undefined): boolean {
  return clusterKey ? COMMISSION_CLUSTERS.has(clusterKey) : false;
}
